import React from 'react';
import { Box, Typography } from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';

interface QuotaAlertProps {
  remainingTokenQuota: number | null | undefined;
  quotaAlert: string | null | undefined;
}

const QuotaAlert: React.FC<QuotaAlertProps> = ({ remainingTokenQuota, quotaAlert }) => {
  if (remainingTokenQuota === null || remainingTokenQuota === undefined) return null;

  const isExceeded = remainingTokenQuota <= 0;
  const isWarning = !isExceeded && remainingTokenQuota <= 30;

  if (!isWarning && !isExceeded) return null;

  return (
    <Box display="flex" alignItems="center" gap={1} px={1.5} py={0} sx={{ userSelect: 'none' }}>
      {isExceeded ? (
        <>
          <ErrorOutlineRoundedIcon fontSize="small" sx={{ color: 'error.main', flexShrink: 0 }} />
          <Typography variant="caption" sx={{ color: 'error.main', fontWeight: 500 }}>
            Your token quota has been fully consumed. Please contact your administrator to increase your quota.
          </Typography>
        </>
      ) : (
        <>
          <WarningAmberRoundedIcon fontSize="small" sx={{ color: 'warning.main', flexShrink: 0 }} />
          <Typography variant="caption" sx={{ color: 'warning.dark', fontWeight: 500 }}>
            {quotaAlert}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default QuotaAlert;
